type Props = {
  label: string;
  value: string;
  hint?: string;
  tone?: "default" | "success" | "danger";
};

const TONE: Record<NonNullable<Props["tone"]>, string> = {
  default: "text-ink",
  success: "text-success",
  danger: "text-danger",
};

export default function StatCard({ label, value, hint, tone = "default" }: Props) {
  return (
    <div className="card p-4">
      <div className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</div>
      <div className={`mt-1 num text-2xl font-semibold ${TONE[tone]}`}>{value}</div>
      {hint && <div className="mt-0.5 text-xs text-gray-500">{hint}</div>}
    </div>
  );
}
